import React from 'react';

import toCamelCase from '../../utils/toCamelCase';
import cx from '../../utils/classNames';

import styles from './textField.module.scss';

import type { ReactNode, HTMLProps } from 'react';

export type Props = {
  /** Style name to control appearance of this component from parent component*/
  className?: string;
  /** The content of the component, typically children elements like input, label, etc. */
  children: ReactNode;
} & HTMLProps<HTMLDivElement>;

export function TextField(props: Props) {
  const { className, children, ...rest } = props;

  return (
    <div className={cx(styles[toCamelCase('textField', 'container')], className)} {...rest}>
      {children}
    </div>
  );
}
export default TextField;
